import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';

const chatRequestHandler = {

  getSignature: (): Promise<ApiResponse<string>> => {

    return genericApi.get('chat/signature');
  },
  joinChatRoom: (obj: { awbNumber?: string, awbCode?: string, pickupOrderId?: number }): Promise<ApiResponse<boolean>> => {

    if (obj.awbCode) return genericApi.post('chat/join/' + obj.awbCode + '/' + obj.awbNumber, {});
    return genericApi.post('chat/join/' + obj.pickupOrderId, {});
  }
};

export default chatRequestHandler;